module.exports = __webpack_public_path__ + "static/laboheme8s-7c54a7c259604165b79c008b8ddfb429.jpg";